// Units in milliseconds
export const millisecondsInSecond = 1000;
export const millisecondsInMinute = millisecondsInSecond * 60;
export const millisecondsInHour = millisecondsInMinute * 60;
export const millisecondsInDay = millisecondsInHour * 24;
export const millisecondsInYear = millisecondsInDay * 365;
